import { Alert, Stack, Typography, List, ListItem } from '@mui/material'
import { useViewerQuery } from '~/generated/graphql'
import { pagesPath } from '~/lib/$path'
import { SimpleDialog } from '~/components/common/SimpleDialog'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { logger } from '~/lib/logger'

export const RequireLineConnectionDialog = () => {
  const { data: viewerData, error } = useViewerQuery({ fetchPolicy: 'network-only' })
  const needLineConnection = viewerData?.viewer.company?.needLineConnection ?? false

  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (needLineConnection) {
      setOpen(true)
    }
  }, [needLineConnection])
  const router = useRouter()

  if (error) {
    return (
      <SimpleDialog
        open={true}
        title="エラーが発生しました"
        okButtonText="ホームに戻る"
        onOk={() => {
          logger.error(error, 'LINE_CONNECTION_VIEWER_QUERY_ERROR')
          router.push(pagesPath.home.$url().pathname)
        }}
      >
        <Stack gap={2} mb={2}>
          <Typography variant="body1">
            アカウント情報の取得中にエラーが発生しました。
          </Typography>
          <Typography variant="body1">
            現在キャンペーンの作成を続行することができません。
          </Typography>
          <Typography variant="body1">
            しばらく時間をおいてから再度お試しください。
          </Typography>
        </Stack>
      </SimpleDialog>
    )
  }

  return (
    <SimpleDialog
      open={open}
      title="LINEグループ連携のご案内"
      okButtonText="LINE連携に進む"
      onOk={() => {
        router.push(pagesPath.line.connect.$url().pathname)
      }}
    >
      <Stack gap={2} mb={2}>
        <Typography variant="body1" fontWeight="bold">
          キャンペーンを作成する際や、お問い合わせをご希望される場合にLINEグループ連携が必要です。
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          ※連携完了後に、キャンペーンを作成していただけます。
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          右下の「LINE連携に進む」をクリックし、ご対応をお願いいたします。
        </Typography>
        <Alert severity="info" sx={{ gap: 1 }}>
          <Typography variant="body1" fontWeight="bold">LINEグループ連携のメリット</Typography>
          <List dense>
            <ListItem disableGutters>・差し戻しや公開などのお知らせをLINEですぐにチェックできます</ListItem>
            <ListItem disableGutters>・LINE通知で大事な情報の見逃しを防げます</ListItem>
          </List>
        </Alert>
      </Stack>
    </SimpleDialog>
  )
}
